export function deleteRecord<T>(array: T[], index: number): T[] {
    if (!(index >= 0)) {
        return array;
    }

    return [...array.slice(0, index), ...array.slice(index + 1)];
}
